module.exports = __webpack_public_path__ + "img/recommend.648ebffa.svg";